export default __webpack_public_path__ + "static/media/Lexus-Logo-White.b5f9577e.svg";